import React, { useEffect, useState } from 'react';
import { BsArrowLeftShort } from 'react-icons/bs';
import { FiSearch } from 'react-icons/fi';
import { GoPlus } from 'react-icons/go';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { useActiveTab } from '../../../../../components/map/components/hooks/useActiveTab';
import { setEditingPinId } from '../../../../../store/slices/projectItemSlice';
import { handleBlockEnter } from '../../../Helpers/constants/constant';
import BulkUploadPin from '../../../Helpers/modal/BulkUploadModal';
import { ProPinModal } from '../../../Helpers/modal/proPinModal';
import PaymentForm from '../../../../../components/stripe/payment';

import { useProductList } from './hooks/useProductList';
import ProductItem from './components/ProductItem';
import { useProjectHeader } from '../../../Helpers/pageDiv/ProjectHeaderContext';
import { toast } from 'react-toastify';

const ProductSideBar = () => {

    useActiveTab('all');

    const dispatch     = useDispatch();
    const navigate     = useNavigate();
    const projectData  = useSelector((state) => state.api.projectData);
    const pinCount     = useSelector((state) => state.api.pinCount);
    const pinsLoaded   = useSelector((state) => state.api.pinsLoaded);
    const currentFloor = useSelector((s) => s.api.currentFloor);

    const [mapDivSize, setMapDivSize]   = useState(window.innerHeight);
    const [modal, setModal]             = useState(false);
    const [planDetails, setPlanDetails] = useState(null);
    const [stripeModal, setStripeModal] = useState(false);
    const [modalBulk, setModalBulk]     = useState(false);

    const {
        filteredList,
        searchTerm,
        setSearchTerm,
        handleAddNew,
        handleAddGroup,
        handleAddGroupProduct,
        movePinToGroup,
        handleEdit,
        handleRemove,
        handleCreateProduct,
        refreshProducts,
        getList,
    } = useProductList({ setModal, setPlanDetails });

    const { handleEnableDisable }  = useProjectHeader();

    useEffect(() => {
        dispatch(setEditingPinId(null));
    }, []);

    useEffect(() => {
        const handleResize = () => setMapDivSize(window.innerHeight);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const goBack = () => {
        navigate(-1);
        setSearchTerm('');
    };

    const bulkUploadClick = (type) => {
        if (currentFloor?.enc_id) {
            setModalBulk(type)
        } else {
            toast.warning('Please select a floor plan to bulk upload.')
        }
    };

    return (
        <div className="bar" id="inner-customizer2" style={{ position: 'relative', height: mapDivSize, paddingBottom: '20px' }}>
            <Row className='backRow'>
                <Col md={8}>
                    <h1>Product Pins</h1>
                </Col>
                <Col md={4}>
                    <div className='backArrow float-right' onClick={goBack}>
                        <BsArrowLeftShort />
                    </div>
                </Col>
            </Row>

            <Formik
                initialValues={{
                    location_name: '! New location',
                    tags:          projectData?.location_tags ?? [],
                    position:      null,
                    enc_id:        null,
                }}
                onSubmit={handleCreateProduct}
            >
                {({ handleSubmit }) => (
                    <>
                        <form
                            id="productForm"
                            className="av-tooltip tooltip-label-bottom formGroups"
                            onSubmit={(e) => handleSubmit(e)}
                        >
                            <> 
                                <div className='bar-sub-header' style={{ marginRight: '14px' }}>
                                    <p style={{ marginTop: 0 }}>Add New Product Pin</p>
                                    <div className='plus-icon' onClick={handleAddNew}>
                                        <GoPlus />
                                    </div>
                                </div>

                                
                                <div className='bar-sub-header pin-group' style={{ marginRight: '14px' }}>
                                    <p style={{ marginTop: 0 }}>Add New Pin Group</p>
                                    <div className='plus-icon' onClick={handleAddGroup}>
                                        <GoPlus />
                                    </div>
                                </div>

                                
                                <div className='mb-2 text-right d-grid gap-2' style={{ marginRight: '14px' }}>
                                    <Button
                                        className="btn-primary bar-btn"
                                        type="button"
                                        size="medium"
                                        onClick={() =>  bulkUploadClick(1)}
                                    >
                                        Bulk Group Product Upload
                                    </Button>
                                </div>

                                <div className='mb-2 text-right d-grid gap-2' style={{ marginRight: '14px' }}>
                                    <Button
                                        className="btn-primary bar-btn"
                                        type="button"
                                        size="medium"
                                        onClick={() => bulkUploadClick(2)}
                                    >
                                        Bulk Product Upload
                                    </Button>
                                </div>

                                
                                <div className="d-flex bar-search mb-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        onKeyDown={(e) => handleBlockEnter(e)}
                                    />
                                    <div
                                        className="input-group-append"
                                        style={{ marginLeft: '-36px' }}
                                    >
                                        <span
                                            className="input-group-text"
                                            style={{
                                                border:          'none',
                                                backgroundColor: 'transparent',
                                                padding:         '4px',
                                            }}
                                        >
                                            <FiSearch className="iconStyle" />
                                        </span>
                                    </div>
                                </div>

                                
                                <div
                                    className='custom-scrollbar customScroll'
                                    style={{ height: mapDivSize - 275 }}
                                >
                                    {!pinsLoaded ? (
                                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading…</span>
                                            </div>
                                        </div>
                                    ) : (
                                        filteredList.map((product, idx) => (
                                            <ProductItem
                                                key={product.enc_id}
                                                index={idx}
                                                product={product}
                                                onEdit={handleEdit}
                                                onRemove={handleRemove}
                                                onAddGroupProduct={handleAddGroupProduct}
                                                movePinToGroup={movePinToGroup}
                                                onRefresh={refreshProducts}
                                            />
                                        ))
                                    )}
                                </div>
                            </>

                            <Button
                                type="submit"
                                id='productSubmitBtn'
                                hidden
                            >
                                Submit
                            </Button>
                        </form>
                    </>
                )}
            </Formik>

            <ProPinModal
                isOpen={modal}
                toggle={() => setModal((v) => !v)}
                totalPinsUsed={pinCount}
                planDetails={planDetails}
                addCardDetails={() => { setModal(false); setStripeModal(true); }}
                projectSettings={projectData}
            />
            <PaymentForm
                toggleStripe={() => setStripeModal((v) => !v)}
                stripeModal={stripeModal}
                planDetails={planDetails}
                project_id={projectData?.enc_id}
                fromUpgrade={false}
            />
            <BulkUploadPin
                modal={modalBulk}
                setModal={setModalBulk}
                type="product"
                projectSettings={projectData}
                getList={getList}
                handleEnableDisable = {handleEnableDisable}
            />
        </div>
    );
};

export default ProductSideBar;
